import { FlowSpec } from '@digibee/flow';

import {
  canvasStoresToFlowSpec,
  useCanvasStore,
  useComponentConfigStore,
  useTrackStore
} from '..';

export function generateFlowSpecFromStores(): FlowSpec {
  const { edges } = useCanvasStore.getState();
  const { tracks } = useTrackStore.getState();
  const configs = useComponentConfigStore.getState().configurations;

  return canvasStoresToFlowSpec(edges, configs, tracks);
}
